import React, {useCallback, useEffect, useState} from 'react';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import './styles.css';
import CompanyLogo from '../../../../components/CompanyLogo';
import LoadMask from '../../../../components/LoadMask';
import RatingButtonsGroup from '../../../../components/RatingButtonsGroup';
import ReadMore from '../../../../components/ReadMore';
import ENDPOINT from '../../../../constants/endpoints';
import LinkBuilder from '../../../../helpers/link-builder';
import useApi from '../../../../hooks/useApi';
import ResponseErrorDialog from '../../../Dialog/components/ResponseErrorDialog';

const RateTheFollowingDeals = props => {
  const { onSetMark } = props;

  const api = useApi();
  const [state, setState] = useState({
    init: false,
    items: [],
  });

  const fetchItems = useCallback(() => {
    api.get(
      ENDPOINT.OTHER.RATE_FOLLOWING_DEALS,
      {},
      {
        handleSuccess: responseData =>
          setState({
            init: true,
            items: [...responseData],
          }),
      }
    );
  }, [api]);

  useEffect(() => {
    fetchItems();
  }, [fetchItems]);

  const sendMark = (firmID, id, mark) => {
    setState(state => ({ ...state, init: false }));
    api.post(
      ENDPOINT.ACTION.FIRM.POST_PORTFOLIO_DEAL_MARK,
      {
        id: firmID,
        emId: id,
        mark,
      },
      {
        handleError: response => ResponseErrorDialog({ response }),
        handleSuccess: () => {
          onSetMark(id);
          fetchItems();
        },
      }
    );
  };

  return state.items.length > 0 ? (
    <div className="rate-the-following-deals">
      {!state.init && <LoadMask relative />}
      <h3 className="rate-the-following-deals__title">
        Rate the following deals
      </h3>
      <div className="rate-the-following-deals__list">
        {state.items.map(item => {
          const link = LinkBuilder.getFirmLink(item.FirmUrlAlias);

          return (
            <div
              className="rate-the-following-deals__item"
              key={item.PortfolioItemID}
            >
              <div className="rate-the-following-deals__item-header">
                <div className="rate-the-following-deals__item-logo">
                  <CompanyLogo
                    name={item.FirmName}
                    logo={item.Logo}
                    link={link}
                    styles={{
                      width: '80px',
                      height: '80px',
                      fontSize: '0.8571rem',
                    }}
                  />
                </div>
                <div className="rate-the-following-deals__item-details">
                  {link ? (
                    <NavLink
                      to={link}
                      className="rate-the-following-deals__item-link"
                    >
                      {item.FirmName}
                    </NavLink>
                  ) : (
                    <span className="rate-the-following-deals__item-strong">
                      {item.FirmName}
                    </span>
                  )}
                  <div className="rate-the-following-deals__item-meta">
                    {item.OwnerID && (
                      <div className="rate-the-following-deals__item-owner">
                        <span className="rate-the-following-deals__text">
                          {item.Type === 'Current' ? 'Portfolio of' : 'Sold by'}
                          :
                        </span>{' '}
                        <NavLink
                          to={LinkBuilder.getFirmLink(item.OwnerFirmUrlAlias)}
                          className="rate-the-following-deals__item-link rate-the-following-deals__item-link--small"
                        >
                          {item.OwnerName}
                        </NavLink>
                      </div>
                    )}
                    <div className="firm-portfolio-list__buttons">
                      <RatingButtonsGroup
                        onChange={mark =>
                          sendMark(item.OwnerID, item.PortfolioItemID, mark)
                        }
                        positive={Number(item.MarkStatGood)}
                        negative={Number(item.MarkStatBad)}
                        disabled={false}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="rate-the-following-deals__item-content">
                {item.Transaction && (
                  <div className="rate-the-following-deals__description">
                    <span className="rate-the-following-deals__text">
                      Transaction:
                    </span>

                    <ReadMore
                      text={item.Transaction}
                      readMoreCharacterLimit={70}
                    />
                  </div>
                )}

                {item.Description && (
                  <div className="rate-the-following-deals__description">
                    <span className="rate-the-following-deals__text">
                      Description:
                    </span>

                    <ReadMore
                      text={item.Description}
                      readMoreCharacterLimit={75}
                    />
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  ) : null;
};

RateTheFollowingDeals.propTypes = {
  onSetMark: PropTypes.func,
};

export default RateTheFollowingDeals;
